import { Media } from "../../types/media";
import Api from "../api";

export default async function apiGetMedia(id: string) {
  return await Api.get<Media>({
    input: `/api/v1/media/${id}`,
  });
}
